import type { APIConfig } from '../../types';

export const DEFAULT_API_CONFIG: APIConfig = {
  delays: {
    createSession: 300,
    saveState: 200,
    getState: 150,
    fetchTimeSlots: 250,
    reserveTime: 150,
    getSignUrl: 100
  }
};
